(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("qsutils", [], factory);
	else if(typeof exports === 'object')
		exports["qsutils"] = factory();
	else
		root["qsutils"] = factory();
})(window, function() {
return 